import { Component,ViewChild, OnInit,Output, Input,HostListener,EventEmitter,ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';


import { BsModalComponent, BsModalBodyComponent, BsModalService } from 'ng2-bs3-modal';
import 'jquery'
import 'bootstrap'

//import { Lists_cmmt } from '../../../routes/menu'


const swal = require('sweetalert');
@Component({
  selector: 'app-daotao-nhacviecedit',
  templateUrl: './nhacviecedit.component.html',
    //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./nhacviecedit.component.scss'],
    providers: [ListService, Repository]
})


export class nhacvieceditComponent implements OnInit {
  doanhnghiepid: string = null;
  public ngaysinh: Date = null;
  public ngaycmnd: Date = null;
  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  inputparents: any;
  inputhangbaohiems: any;
  inputphongbans: any;
  inputhangxes: any;
  inputkhachhangs: any;
  inputmausacs: any;
  inputmodels: any;
  inputnhomctmts: any;
  indLoading: boolean = false;
  totalItems: number = 0;
  dslops: any;
  doituongSelect: any = {
    Id: null, DonViId: null, NoiDung: null, NguoiNhan: null
    , TrangThai: null, GhiChu: null
    ,Created: null, Modified: null, CreatedBy: null, ModifiedBy: null
    , DSNguoiNhan: []
  };       
    nhomdtid:string=null;
  hoatdong: string = null;
  inputnhacungcaps: any = [
    { Ten_Doi_Tuong: "Cá nhân", Ma_Doi_Tuong: '0', Id: false },
    { Ten_Doi_Tuong: "Tổ chức", Ma_Doi_Tuong: '1', Id: true },
  ];

  dstrangthais: any = [
    { Ten: 'Chờ xử lý', Id: 0 },
    { Ten: 'Đang xử lý', Id: 1 },
    { Ten: 'Không xử lý', Id: 2 },
    { Ten: 'Hoàn thành', Id: 3 }
  ];

  inputthus: any = [
    { Ten: 'Thứ 2', Id: 2 },
    { Ten: 'Thứ 3', Id: 3 },
    { Ten: 'Thứ 4', Id: 4 },
    { Ten: 'Thứ 5', Id: 5 },
    { Ten: 'Thứ 6', Id: 6 },
    { Ten: 'Thứ 7', Id: 7 },
    { Ten: 'Chủ nhật', Id: 8 }
  ];

  inputgioitinhs: any = [
    { Ten_Doi_Tuong: "Nữ", Ma_Doi_Tuong: '0', Id: false },
    { Ten_Doi_Tuong: "Nam", Ma_Doi_Tuong: '1', Id: true },
  ];

  inputloais: any = [
    { text: "Nhân công", value: 0 },
    { text: "Vật tư sơn", value: 1 },
  ];

  @ViewChild('slCapTren', { static: false }) slCapTren: NgSelectComponent;
  @Output() save: EventEmitter<any> = new EventEmitter();

  public currentPage: number = 1;
  public maxSize: number = 5;
  public TimKiem: string;
  public StartPage: number = 1;
  public EndPage: number = 50;
  public pageSize: number = 50;
  public pages: any;
  public totalPages: number;
  public TimKiems: any = {
    DonViId: null
    , LopId: null
    , UserName: null
    , TuNgay: null
    , DenNgay: null
    , TimKiem: null
    , startPage: null
    , endPage: null
    , curPage: null
    , TrangThai: null
    , TrangThaiS: null
    , Modified: null
    , ModifiedS: null
    , ModifiedBy: null
    , SapXep: null
    , HienThiTatCa: false
  };

  Password: string = null;
  PasswordNew: string = null;
  PasswordConfirm: string = null;
  username: string = null;
  public ngxCurrencyOptions = {
    prefix: '',
    thousands: ',',
    decimal: '.',
    precision: 0,
    allowNegative: false
  };

    constructor( private _dataService: ListService, public repo: Repository) {
       
        
    }

    ngOnInit(): void {
       
    }

    // @HostListener('document:keydown', ['$event'])
    // public handleKeyboardEvent(event: KeyboardEvent): void {
      
    //   if(event.key==="F9")
    //   {
    //       this.saveproduct();
    //   }
    //   event.stopPropagation();
     
    // }

    comboSearchFn(term: string, item: any) {
        term = term.toLowerCase();
        return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
    }
  @ViewChild("mafocus", { static: false }) mafocus: ElementRef;
  bnguonkinhphi: boolean = false;
  bnhomctmt: boolean = false;
  currentUser: any;
  tieudectmt: any;
  tieudectmtplace: any;
  hosoid: string;
  TaiKhoan: string;
  datas: any;
 
  loadDataInit(nhomdoituongid: string, id: string, donviid: string, rowdata: any, hocvienid: string) {

    this.doituongSelect = {
      Id: null, DonViId: null, NoiDung: null, NguoiNhan: null
      , TrangThai: 0, GhiChu: null
      , Created: null, Modified: null, CreatedBy: null, ModifiedBy: null
      , DSNguoiNhan: []
    };

   


    this.hosoid = hocvienid;
    var authlogin = localStorage.getItem('currentUser');
          if (authlogin) {

            this.currentUser = JSON.parse(authlogin);
            this.username = this.currentUser.user_name;
            this.doituongSelect.Created = new Date();
            this.doituongSelect.CreatedBy = this.currentUser.user_name;
            this.doituongSelect.Modified = new Date();
            this.doituongSelect.ModifiedBy = this.currentUser.user_name;
            this.doituongSelect.DonViId = this.currentUser.id_don_vi;
            this.TimKiems.DonViId = this.currentUser.id_don_vi;
            this.TimKiems.UserName = this.currentUser.user_name;

    }

    this.repo.postRequest("api/hoso/combonhansuhotro", { DonViId: this.currentUser.id_don_vi })
      .subscribe(response => {
        this.dslops = response;
      });

    

    this.loaddatas();
     


  }
  getbyid() {
    this.repo.postRequest("api/nhacviec/getbyid/", { IdGuid: this.tId  })
      .subscribe(response => {
        if (response != null) {
          this.doituongSelect.Created = new Date(response.Created);
          this.doituongSelect.CreatedBy = response.CreatedBy;
          this.doituongSelect.GhiChu = response.GhiChu;
          this.doituongSelect.NoiDung = response.NoiDung;
          this.doituongSelect.TrangThai = response.TrangThai;
          this.doituongSelect.Id = response.Id;
          this.doituongSelect.DonViId = response.DonViId;
          this.doituongSelect.Modified = new Date();
          this.doituongSelect.ModifiedBy = this.currentUser.user_name;
          if (response.DSNguoiNhan != null)
            this.doituongSelect.DSNguoiNhan = response.DSNguoiNhan;
          else
            this.doituongSelect.DSNguoiNhan = [];
        }

      });
  }
   
  public ngonngu(text: string) {
    return this.repo.NgonNgu(text);
  }
    public closeModal(){
        this.save.emit(null);
  }

  comboSearchFn2(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ten.toLowerCase().indexOf(term) > -1;
  }
  ThucHien() {
    if (this.doituongSelect.Created == null) {
      swal('Lỗi!', "Vui lòng nhập ngày tạo.", 'error');
      return;
    }
    if (this.doituongSelect.NoiDung == null) {
      swal('Lỗi!', "Vui lòng nhập nội dung.", 'error');
      return;
    }
    
    this.repo.postRequest("api/nhacviec/addorupdate/", this.doituongSelect
    )
      .subscribe(response => {
        if (response != null && response.match('OK')) {
          swal('Saved!', 'Lưu thành công!.', 'success');
          this.doituongSelect.Id = response.Id;
          this.loaddatas();
         // this.save.emit(this.doituongSelect);
        }
        else if (response != null) {
          swal('Lỗi!', response, 'error');
        }

        console.log(response);

      });
  }

  

  deleterow(index: string) {
    //console.log(index);
    swal({
      title: 'Bạn muốn xóa dòng này phải không?',
      text: 'Dữ liệu xóa sẽ không phục hồi lại được!',
      icon: "warning",
      buttons: {
        cancel: {
          text: 'Hủy bỏ',
          value: false,
          visible: true,
        },
        confirm: {
          text: 'Đồng ý',
          value: true,
          visible: true,
          className: "bg-danger",
          closeModal: true
        }
      }
    })
      .then(willDelete => {
        if (willDelete) {
          this.repo.postRequest("api/nhacviec/delete/", { IdGuid: this.datas[index].Id }
          )
            .subscribe(response => {
              if (response != null && response.match('OK')) {
                this.loaddatas();
              }
              else if (response != null) {
                swal('Lỗi!', response, 'error');
              }

              console.log(response);

            });
          this.datas.splice(index, 1);
        }
      });


  }
   
  mBackdrop: any;
  haveBackdrop() {
    if ($('.modal-backdrop').length > 0) {
      $('.modal-backdrop').css("z-index", -1)
      clearTimeout(this.mBackdrop);
      return true;
    }

    return false;
  }
  indexdt: number;
  cotdt: string;


  loaddatas() {
    this.repo.postRequest("api/nhacviec/get_listviewpage/", this.TimKiems
    )
      .subscribe(response => {
        if (response != null) {
          this.datas = response;
          this.totalItems = this.datas.length;
        }
        

      });
  }
  tId: any = null;
  selectedRow: any;
  selected(row: any) {
    this.tId = row.Id;
    this.selectedRow = row;
    this.doituongSelect = {
      Id: null, DonViId: null, NoiDung: null, NguoiNhan: null
      , TrangThai: 0, GhiChu: null
      , Created: null, Modified: null, CreatedBy: null, ModifiedBy: null
      , DSNguoiNhan: []
    };
    this.doituongSelect.Id = row.Id;
    this.doituongSelect.DonViId = row.DonViId;
    this.doituongSelect.NoiDung = row.NoiDung;
    this.doituongSelect.NguoiNhan = row.NguoiNhan;
    this.doituongSelect.TrangThai = row.TrangThai;
    this.doituongSelect.GhiChu = row.GhiChu;
    this.doituongSelect.Created = row.Created;
    this.doituongSelect.CreatedBy = row.CreatedBy;
    this.doituongSelect.Modified = row.Modified;
    this.doituongSelect.ModifiedBy = row.ModifiedBy;
    this.doituongSelect.DSNguoiNhan = [];
    if (row.NguoiNhan != null) {
      this.doituongSelect.DSNguoiNhan = row.NguoiNhan
        .split(",")
        .map(x => Number(x.trim()));
    }

    this.doituongSelect.Modified = new Date();
    this.doituongSelect.ModifiedBy = this.currentUser.user_name;
  }

  LamMoi() {
    this.doituongSelect = {
      Id: null, DonViId: this.currentUser.id_don_vi, NoiDung: null, NguoiNhan: null
      , TrangThai: 0, GhiChu: null
      , Created: null, Modified: null, CreatedBy: null, ModifiedBy: null
      , DSNguoiNhan: []
    };
    this.tId = null;
    this.selectedRow = null;
    this.doituongSelect.Created = new Date();
    this.doituongSelect.CreatedBy = this.currentUser.user_name;
    this.doituongSelect.Modified = new Date();
    this.doituongSelect.ModifiedBy = this.currentUser.user_name;
  }

  onHienThiTatCaChange() {
    this.loaddatas();
  }


}
